module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Multi-factor authentication","subtitle":"Your account is secured using multi-factor authentication (MFA). To finish signing in, check your email for a six digit code and enter it below.","submit":"Submit","cancel":"Cancel","authenticationFailed":"Authenication Failed"}}')
  delete Component.options._Ctor
}
